module.exports = __webpack_public_path__ + "media/images/logo-klarna-9b5c37230ad4ad0516f6bca3c66134a5.svg";